import * as React from 'react';

import {FormField} from 'shells/form/form-field';

import type {TagType} from 'nutshell-graphql-types';
// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {TagSelectSingle} from './tag-select-single';

type Props = FieldProps & {
    fieldKey: string;
    title: string;
    isRequired: boolean;
    validate: (...args: any) => any;
    tagType: TagType;
};

export function TagSelectField(props: Props) {
    return (
        <FormField
            key={props.fieldKey}
            innerId={props.fieldKey}
            label={props.title}
            isRequired={props.isRequired}
            // @ts-expect-error
            validate={props.validate}
        >
            <TagSelectSingle {...props} name={props.fieldKey} />
        </FormField>
    );
}
